import React, { useRef } from 'react'
import { createPortal } from 'react-dom'
import { withRouter } from 'react-router-dom'

import Burger from '../Burger'
import Button from '../Button'
import { addAnimationEndListeners } from '../../utils/eventListeners'
import { StyledMenu, StyledLinkWrapper, Wrapper, Mask, Container } from './Menu.styled'

const Modal = ({
  children,
  isOpen = false,
  close,
  elementId = 'root',
  modalRef
}) => {
  if (isOpen === false) {
    return null
  }

  return createPortal(
    <Wrapper onClick={close}>
      <Mask />
      <Container ref={modalRef}>{children}</Container>
    </Wrapper>,
    document.getElementById(elementId)
  )
}

const Menu = ({ history, match }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const menuContent = [{
    label: 'Hovedmeny',
    link: '/menu'
  },
  {
    label: 'Om kurset',
    link: '/about/page-1'
  },
  {
    label: 'Lukk kurs',
    action: () => {
      window.close()
    }
  }]

  const modalRef = useRef()
  const open = () => {
    setIsOpen(true)
  }
  const close = () => {
    addAnimationEndListeners(modalRef.current, () => setIsOpen(false))
    modalRef.current.classList.add('leaving')
  }
  const handleLinkClick = (menuItem) => {
    if (menuItem.action) { menuItem.action() } else if (menuItem.link) { history.push(menuItem.link) } else if (menuItem.href) { window.location.href = menuItem.href }
    setIsOpen(false)
  }
  return (
    <>
      <Burger isOpen={isOpen} open={open} close={close} />
      {isOpen &&
        <Modal modalRef={modalRef} isOpen={isOpen} close={close}>
          <StyledMenu>
            <h2>Meny</h2>
            <StyledLinkWrapper>
              {menuContent.map((menuItem, index) =>
                <Button classes={['menu-button']} placeholder={menuItem.label} tabIndex={index + 2} key={menuItem.label} handleClick={() => handleLinkClick(menuItem)} />
              )}
            </StyledLinkWrapper>
          </StyledMenu>
        </Modal>}
    </>
  )
}
export default withRouter(Menu)
